import { useSessionTimeout } from '../hooks/useSessionTimeout'
import { Clock } from 'lucide-react'

export function SessionTimeoutWarning() {
  const { minutesRemaining, isExpiringSoon, isExpiryCritical, refresh } = useSessionTimeout()

  if (!isExpiringSoon || minutesRemaining === null) return null

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-3 px-4 py-2 text-sm font-medium ${
        isExpiryCritical
          ? 'bg-red-600 text-white'
          : 'bg-amber-500 text-white'
      }`}
    >
      <Clock className="h-4 w-4 shrink-0" />
      <span>
        {isExpiryCritical
          ? 'Your session expires in less than 1 minute. Save your work now.'
          : `Your session expires in ${minutesRemaining} minute${minutesRemaining === 1 ? '' : 's'}.`}
      </span>
      <button
        onClick={refresh}
        className="rounded-md border border-white/30 bg-white/20 px-3 py-1 text-xs font-medium hover:bg-white/30 transition-colors"
      >
        Extend Session
      </button>
    </div>
  )
}
